import axios from 'axios'
import Vue from 'vue'
import { UPLOAD_ROOT } from '@/common/constants'
import { getWebToken, defaultParams } from '@/common/utils/common'

function upload(file) {
  var formData = new FormData()
  formData.append('file', file, file.name)
  formData.append('encryptType', 100)

  return axios
    .post(UPLOAD_ROOT, formData, {
      withCredentials: false,
      onUploadProgress: function(progressEvent) {
        console.log('progressEvent', progressEvent)
      }
    })
    .then(res => {
      console.log('upload res', res)
      if (res.data.status === 200) {
        return res.data
      } else {
        Vue.prototype.$message.success(res.data.message)
      }
    })
}

const default_config = {
  isPrivate: false,
  errorMsg: '上传失败'
}

function uploadFile(file, config = default_config) {
  config = { ...default_config, ...config }
  const { isPrivate, errorMsg, extraParam, onProgress } = config

  let param = new FormData()
  param.append('file', file.raw, file.name)
  param.append('_aid', defaultParams.aid.business_pc)
  param.append('_fs', isPrivate ? '1' : '0')
  if (isPrivate) {
    param.append('_tk', getWebToken())
  }

  if (extraParam) {
    Object.keys(extraParam).forEach(key => {
      param.append(key, extraParam[key])
    })
  }

  let axiosConfig = {}
  if (onProgress && typeof onProgress === 'function') {
    axiosConfig.onUploadProgress = onProgress
  }

  return new Promise((resolve, reject) => {
    axios
      .post(UPLOAD_ROOT, param, axiosConfig)
      .then(res => {
        let { status, data } = res
        if (status === 200 && data.status === 200 && data.data) {
          resolve(data.data)
        } else {
          Vue.prototype.$message.error(data.message ? data.message : '上传失败')
          reject('上传失败')
        }
      })
      .catch(() => {
        Vue.prototype.$message.error('上传失败')
        reject('上传失败')
      })
  })
}

export { upload, uploadFile }
